import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the type for a single module parameter item
export interface ModuleParam {
  id?: string | number;
  name?: string;
  code?: string;
  value?: any;
  description?: string;
  module?: string;
  paramType?: string;
  isActive?: boolean;
  [key: string]: any; // Allow for additional properties
}

// Define initial state type
const initialState: ModuleParam[] = [];

// Create a slice for module parameters
const moduleParamJsonSlice = createSlice({
  name: "moduleParamJson",
  initialState,
  reducers: {
    // Action to set module parameters
    setmoduleParamJson: (_state: ModuleParam[], action: PayloadAction<ModuleParam[]>) => {
      console.log("Module param payload received:", action.payload);
      return action.payload;
    },
    // Action to clear module parameters
    clearmoduleParamJson: (): ModuleParam[] => {
      return [];
    },
    // Optional: Add action to add a single module parameter
    addModuleParam: (state: ModuleParam[], action: PayloadAction<ModuleParam>) => {
      state.push(action.payload);
    },
    // Optional: Add action to remove a module parameter
    removeModuleParam: (state: ModuleParam[], action: PayloadAction<string | number>) => {
      return state.filter(param => param.id !== action.payload);
    },
    // Optional: Add action to update a module parameter
    updateModuleParam: (state: ModuleParam[], action: PayloadAction<ModuleParam>) => {
      const index = state.findIndex(param => param.id === action.payload.id);
      if (index !== -1) {
        state[index] = action.payload;
      }
    },
  },
});

// Export actions for use in components
export const { 
  setmoduleParamJson, 
  clearmoduleParamJson,
  addModuleParam,
  removeModuleParam,
  updateModuleParam 
} = moduleParamJsonSlice.actions;

// Export reducer to be included in the store
export default moduleParamJsonSlice.reducer;

// Export state type for use in selectors
export type ModuleParamState = ReturnType<typeof moduleParamJsonSlice.reducer>;